import Swiper from 'swiper';
import { Navigation, Mousewheel, FreeMode } from 'swiper/modules';

export function alphabeticalFacet() {
    let swiperInstances = {};

    // const url = new URL(window.location.href);
    // const language = url.searchParams.get('language');

    const swiperOptions = {
        slidesPerView: 'auto',
        modules: [Navigation, Mousewheel, FreeMode],
        spaceBetween: 0,
        slideClass: 'facetwp-alpha',
        wrapperClass: 'facetwp-facet-alphabetical', /* + (language !== '' ? '_' + language : ''), */
        preventClicks: true,
        preventClicksPropagation: true,
        navigation: {
            nextEl: '.swiper-nav--next',
            prevEl: '.swiper-nav--prev',
        },
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        forceToAxis: true,
        mousewheel: {
        },
        freeMode: {
            enabled: true,
            sticky: true,
        },
    };

    document.addEventListener('facetwp-loaded', function() {
        // Destroy the swipers before creating new ones
        if(swiperInstances.alphaFacetSwiperTop) {
            swiperInstances.alphaFacetSwiperTop.destroy();
        }
        if(swiperInstances.alphaFacetSwiperBottom) {
            swiperInstances.alphaFacetSwiperBottom.destroy();
        }

        const container = document.querySelectorAll('.swiper-top .facetwp-alpha');
        const selectedEl = document.querySelector('.swiper-top .facetwp-alpha.selected');
        swiperOptions.initialSlide = [...container].indexOf(selectedEl);
        
        // Make the facet scrollable via swiper
        swiperInstances.alphaFacetSwiperTop = new Swiper('.swiper-top', swiperOptions);
        swiperInstances.alphaFacetSwiperBottom = new Swiper('.swiper-bottom', swiperOptions);

        //Sync bottom facet  scroll to top facet
        swiperInstances.alphaFacetSwiperTop.on('progress', function(swiper, progress) {
            swiperInstances.alphaFacetSwiperBottom.setProgress(progress);
        });

        
        // Update facets on alpha-facet click. Needed because bottom facet is not updated otherwise.
        swiperInstances.alphaFacetSwiperTop.el.querySelectorAll('.facetwp-alpha').forEach((option) => addFacetClickActions(option));
        swiperInstances.alphaFacetSwiperBottom.el.querySelectorAll('.facetwp-alpha').forEach( (option) => addFacetClickActions(option));

        function addFacetClickActions(facet) {
            facet.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                
                if(this.classList.contains('available')) {
                    FWP.facets['alphabetical'] = facet.dataset.id;
                    FWP.fetchData();
                    FWP.setHash();
                }

                setTimeout(() => {
                    document.querySelector('.facetwp-template').scrollIntoView();
                }, 500);
                document.querySelector('.facetwp-template').scrollIntoView();

            });
        }
        
        // Set visibility on bottom facet based on post count
        const postsContainer = document.querySelector('.facetwp-template');
        const numberOfArticles = postsContainer.querySelectorAll('article').length;

        if(numberOfArticles < 4) {
            swiperInstances.alphaFacetSwiperBottom.hostEl.classList.remove(...['md:block']);
            swiperInstances.alphaFacetSwiperBottom.hostEl.classList.add(...['hidden']);
        } else if(numberOfArticles < 7) {
            swiperInstances.alphaFacetSwiperBottom.hostEl.classList.remove(...['md:block', 'hidden']);
            swiperInstances.alphaFacetSwiperBottom.hostEl.classList.add(...['sm:hidden', 'lg:hidden']);
        } else if(numberOfArticles < 10) {
            swiperInstances.alphaFacetSwiperBottom.hostEl.classList.add(...['sm:hidden', 'md:block', 'hidden']);
        } else {
            swiperInstances.alphaFacetSwiperBottom.hostEl.classList.remove(...['sm:hidden', 'md:block', 'lg:hidden', 'hidden']);
        }
    });
}

export function countPostsByCharacter() {
    document.addEventListener('facetwp-loaded', function() {
        const theContainer = document.querySelector('.facetwp-template');
        const countInput = theContainer.querySelectorAll('.char-count');
        
        countInput.forEach((count) => {
            const numberOfArticles = theContainer.querySelectorAll('[data-starting-character="' + count.dataset.currentChar + '"]').length;
            count.innerHTML = numberOfArticles;
        });
    });
}

export function searchFacet() {
    document.addEventListener('facetwp-refresh', function() {
        // Clear alphabetical facet when search is set
        if (null !== FWP.active_facet && FWP.active_facet.attr('data-name') === 'search') {
            FWP.facets['alphabetical'] = [];
        }
    });
}